<div class="px-3 py-2">
	<h4 align="center">LA DE CIFRIS INCONTRA PERUGIA</h4>
	<p>Il <b>16 ottobre 2019</b> si è tenuta una nuova sessione a 
		Perugia della costituenda associazione nazionale di crittografia 
		<i>De Componendis Cifris.</i></p>
	<p>Questa sessione è la seconda dei due sessioni territoriali del 2019.</p>
	<b>Luogo: Università; di Perugia -  Palazzo della Provincia - Sala Consiliare 
		Piazza Italia, 11 - Perugia</b>
	<p>
		L’incontro fa parte di una serie di incontri territoriali patrocinati 
		dall’iniziativa e si propone di offrire una panoramica sulle attività 
		di ricerca nel Centro e nel Sud Italia, riguardanti la Crittografia e 
		le sue applicazioni. Analoga giornata di studio per il Nord Italia si 
		tiene è tenuta a Torino il 14 ottobre. 
		<br>
		Tra gli abiettivi della De Cifris vi è quella di aggregazione delle 
		competenze di Crittografia al fine di stimolare una maggiore collaborazione 
		in ambito crittografico coinvolgendo sia le numerose eccellenze accademiche 
		presenti in Italia, sia il mondo delle aziende che operano nel settore. 
	</p>
	<p><a href="../../../../assets/eventi/2019/Perugia/Locandina-Perugia.pdf">Locandina</a></p>
	<h5>PROGRAMMA</h5>
	<ul>
		<li><p><b>10:00 - 10:20  Registrazione partecipanti</b></p></li>
		<li>
			<p><b>10:20 - 11:40  Sessione I</b></p>
			<ul class="ulSon">
				<li>
					<p>10:20 Professoressa Elena Stanghellini<br>
						Università di Perugia <br>
						<i style="color: green;">Delegato per le relazioni internazionali</i><br>
						Fondazione Cassa di Risparmio di Perugia
					</p>
				</li>
				<li>
					<p>10:30 Professore Gianluca Vinti<br>
						Università di Perugia <br>
						<i style="color: green;">Direttore del Dip.to di Matematica e Informatica</i>
					</p>
				</li>
				<li>
					<p>10:40 Dottoressa Erika Borghesi<br>
						Provincia di Perugia <br>
						<i style="color: green;">Consigliera</i>
					</p>
				</li>
				<li>
					<p>10:50 Professore Massimiliano Sala<br>
						De Componendis Cifris <br>
						<i style="color: green;">Acting Director <br>
							<a href="../../../../assets/eventi/2019/Perugia/Slide_MassimilianoSala_Perugia.pdf">slide</a></i>
					</p>
				</li>
				<li>
					<p>11:10 Capitano di Fregata Daniele Boddi<br>
						Stato Maggiore Difesa - VI Reparto <br>
						<i style="color: green;">Ufficio Sicurezza Sistemi</i>
					</p>
				</li>
				<li>
					<p>11:20 Dottore Diego Monorchio<br>
						CONSOB <br>
						<i style="color: green;">Ufficio Post-Trading <br>
							<a href="../../../../assets/eventi/2019/Perugia/Slide_DiegoMonorchio.pptx">slide</a></i>
					</p>
				</li>
			</ul>
		</li>
		<li><p><b>11.40 - 12.00   Coffee break</b></p></li>
		<li>
			<p><b>12:00 - 13:00  Sessione II</b></p>
			<ul class="ulSon">
				<li>
					<p>12:00 Ing. Vincenzo Iucci<br>
						NTT Data <br>
						<a href="">Code name: BaBeLe - Dati biometrici e crittografia omomorfa</a>
					</p>
				</li>
				<li>
					<p>12:20 Prof. Stefano Bistarelli<br>
						Università di Perugia <br>
   				 	<a href="../../../../assets/eventi/2019/Perugia/Slide_StefanoBistarelli.pdf">Il nodo UNIPG del CyberSecurity National Lab</a>
					</p>
				</li>
				<li>
					<p>12:40 Dott. Marco Timpanella<br>
						Università del Salento <br>
						<a href="../../../../assets/eventi/2019/Perugia/Slide_MarcoTimpanella.pdf">Una concreta applicazione della crittografia su curve ellittiche</a>
					</p>
				</li>
			</ul>
		</li>
		<li><p><b>13:00 - 14:00   Lunch Break</b></p></li>
		<li><p><b>14:00 - 15:20  Sessione III</b></p>
			<ul class="ulSon">
				<li>
					<p>14:00 Prof. Marco Pedicini<br>
						Università di Roma Tre <br>
   					<a href="../../../../assets/eventi/2019/Perugia/Slide_MarcoPedicini.pdf">Crittografia e Crittotecnologie: infrastruttura di comunicazione</a>
					</p>
				</li>
				<li>
					<p>14:20 Ing. Vincenzo Mafrica<br>
						BV Tech <br>
						<a href="../../../../assets/eventi/2019/Perugia/Slide_VincenzoMafrica.pdf">Privatewave, crittografia e comunicazioni sicure </a>
					</p></li>
				<li>
					<p>14:40 Prof. Roberto La Scala<br>
						Università di Bari <br>
						<a href="../../../../assets/eventi/2019/Perugia/Slide_RobertoLaScala.pdf">Cifrari a flusso polinomiali</a>
					</p>
				</li>
				<li>
					<p>15:00 Dott. Donato Cappetta e Chiara Spadafora<br>
						Eustema <br>
						<a href="../../../../assets/eventi/2019/Perugia/Slide_DonatoCappetta.pdf">Blockchain e Secret Sharing</a>
					</p>
				</li>
				<li>
					<p>15:20 Prof. Daniele Bartoli<br>
						Università di Perugia <br>
						<a href="../../../../assets/eventi/2019/Perugia/Slide_DanieleBartoli.pdf">Funzioni non lineari in Crittografia Simmetrica</a>
					</p></li>
			</ul>
		</li>
		<li><p><b>15.40 - 15.50 Coffee break</b></p></li>
		<li><p><b>15:50 - 17:20  Sessione IV</b></p>
			<ul class="ulSon">
				<li>
					<p>15:50 Dott. Sandro Fontana<br>
						GT50 <br>
						<a href="../../../../assets/eventi/2019/Perugia/Slide_SandroFontana.pdf">True Reporter: news source origin verification</a>
					</p>
				</li>
				<li>
					<p>16:10 Prof. Stefano Guarino<br>
						IAC - CNR <br>
   					<a href="../../../../assets/eventi/2019/Perugia/Slide_StefanoGuarino.pdf">Calcolo ad alte prestazioni per attacchi a sistemi crittografici</a>
					</p>
				</li>
				<li>
					<p>16:30 Dott. Andrea Di Cesare<br>
						SoftInstigate <br>
						<a href="../../../../assets/eventi/2019/Perugia/Slide_AndreaDiCesare.pdf">Modelli di business nella Crypto Economy</a>
					</p>
				</li>
				<li><p>16.50 - 17.00 <b>Conclusioni</b></p></li>
			</ul>
		</li>
	</ul>
	<hr>
	<p> Questo evento è stato coordinato a livello nazionale dall'Acting Director della De 
		Componendis Cifris e a livello locale dal Comitato De Cifris, che è rappresentato da:
	</p>
	<p>Dott. Riccardo Aragona - <b>Università del’Aquila</b>. <br>
	Prof. Massimo Giulietti - <b>Università di Perugia</b>. <br>
	Prof. Marco Pedicini - <b>Università di Roma Tre</b>. <br>
	Prof. Ivan Visconti - <b>Università di Salerno</b>.</p>
</div>
  